import React from 'react';
import { Navigate } from 'react-router-dom';
import { canRecordDeadChicken } from '../../constants/permissions';

const RecordPermissionRoute = ({ children }) => {
  if (!canRecordDeadChicken()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RecordPermissionRoute;
